<template>
	<div class="details-sidebar-section"><slot /></div>
</template>

<script>
export default {
	name: 'SidebarSection',
}
</script>

<style lang="scss" scoped>
.details-sidebar-section {
	padding: 16px 12px;
	border-bottom: 1px solid var(--neutral-200);
	&:last-child {
		border-bottom: 0;
	}
}
</style>
